import apisauce from 'apisauce'
import { getApis } from './Api'

export default {
  create: () => {
    const api = apisauce.create({
      baseURL: `${process.env.BASE_URL}/shopify_admin`,
      headers: {
        // Origin: 'https://mukul.ngrok.io',
        'Content-Type': 'application/json',
        // Authorization: `Bearer ${accessToken}`
      },
      timeout: 30000,
    })

    api.axiosInstance.interceptors.request.use(function (config) {
      config.headers['uuid'] = window.shop_uuid
      return config
    })

    return getApis(api)
  },
}
